var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkData)?_c('div',{staticClass:"sidebar-nav"},[_c('div',{staticClass:"sidebar-nav__accordions"},_vm._l((_vm.linkData.topics),function(accordionItem,index){return _c('accordion',{key:index,attrs:{"topic":accordionItem}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }